"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UI =
/** @class */
function () {
  function UI() {}

  UI.clearAll = function (form) {
    form.classList.remove(this.PROGRESS);
    form.classList.remove(this.DONE);
    form.classList.remove(this.ERROR);
  };

  UI.progressState = function (form) {
    this.clearAll(form);
    form.classList.add(this.PROGRESS);
  };

  UI.successState = function (form) {
    form.classList.remove(this.PROGRESS);
    form.classList.add(this.DONE);
  };

  UI.errorState = function (form) {
    form.classList.remove(this.PROGRESS);
    form.classList.add(this.ERROR);
  };

  UI.PROGRESS = 'emailjs-sending';
  UI.DONE = 'emailjs-success';
  UI.ERROR = 'emailjs-error';
  return UI;
}();

exports.UI = UI;